import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function HowToUseAccordion({ title, children }) {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        border: "1px solid #13433a",
        borderRadius: "8px !important",
        "&:before": { display: "none" },
        "&.Mui-expanded": { margin: 0 },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "#13433a" }} />}
        sx={{
          minHeight: 48,
          "&.Mui-expanded": { minHeight: 48 },
          "& .MuiAccordionSummary-content": { margin: "12px 0" },
          "& .MuiAccordionSummary-content.Mui-expanded": { margin: "12px 0" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Kaisei Decol, serif",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#13433a",
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingTop: 0 }}>
        <Box
          sx={{
            fontFamily: "Kiwi Maru, serif",
            fontSize: "14px",
            color: "#13433a",
            lineHeight: 1.8,
          }}
        >
          {children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
